import React from "react";
import { FaChevronLeft } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const NavigateBack = (props) => {
  const { customNavigation, modalNavigation, returnText, zIndex } = props;
  const navigate = useNavigate();

  return (
    <div
      className={`flex items-center fixed top-20 w-full h-10 bg-snappily-orange border-gray-300 
            border-t-1 text-xl text-white p-3 gap-x-3 cursor-pointer ${zIndex}`}
      onClick={() => {
        customNavigation
          ? navigate(customNavigation)
          : modalNavigation
          ? modalNavigation()
          : navigate(-1);
      }}
    >
      <FaChevronLeft />
      <div>{returnText ? returnText : "Back"}</div>
    </div>
  );
};

export default NavigateBack;
